import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch workflow configurations for a specific community group
 */
export const GET_COMMUNITY_GROUP_WORKFLOWS = gql`
  query GetCommunityGroupWorkflows($communityGroupId: ID!) {
    communityGroup(id: $communityGroupId) {
      id
      workflowConfigurations {
        type
        topicActions {
          topicName
          actionNames
        }
      }
    }
  }
`;
